@let _isMobile = isMobile();
@let _isReadOnly = isReadOnly();
@let _isLoading = isLoading();
@let _productInfo = productInfo();
@let _isRegistered = isRegistered();
@let _showAllRef = showAllRef();
@let _isMinified = isMinified();
@let _hasNoActions = hasNoActions();
@let _sourceCurrencyIsocode = sourceCurrencyIsocode();

@if (_isReadOnly && _isMobile) {
  @if (_isLoading) {
    <sd-skeleton
      [appearance]="skeletonAppearanceEnum.line"
      [sizeChangeMobile]="false"
      [count]="1"
    />
  } @else {
    <sd-title customClass="brand--h5 is-text-black" class="c__title-main-mobile">
      {{ _productInfo?.title }}
    </sd-title>
  }
}

<div class="c__media-input">
  <sd-banner
    [media]="(_productInfo?.media ? _productInfo.media : (_productInfo?.bundle?.[0]?.media ? _productInfo.bundle?.[0].media : defaultMedia))"
    [isComponentLoading]="_isLoading"
    [hasAltText]="false"
    [isFit]="true"
    #productCustomerMedia
    class="c__media-wrapper {{ imageHasBorder ? 'has-border' : '' }}"
    [imgRatio]="imageRatio"
  />

  @if (_isMobile && !_isReadOnly && !_isRegistered && !_isLoading) {
    <sd-form select
      #quantitySelector
      [items]="itemQty()"
      [labelTitle]="'product.a11y.quantityLabel' | translate: { productName: _productInfo?.title, productCode: _productInfo?.code }"
      (valueChanged)="notifyQuantity()"
      [labelHidden]="false"
      valueKey="value"
      [selectedValue]="{value: (_productInfo?.quantity ? _productInfo?.quantity : 1)}"
      libelleKey="value"
      nameField="selectQuantity"
      [disabled]="quantityDisabled()"
    />
  }
</div>

<div class="c__body">
  <div class="c__content-left">
    @if (_isLoading) {
      <sd-skeleton
        [appearance]="skeletonAppearanceEnum.line"
        [sizeChangeMobile]="false"
        [count]="4"
      />
    } @else {
      <div class="c__product-info">
        @if (_productInfo?.brandLogoTitle) {
          <sd-banner class="c__brand-logo-title" [isFit]="true" [media]="_productInfo?.brandLogoTitle" />
        }
        @if (!_isMobile || !_isReadOnly) {
          <sd-title customClass="brand--h5 is-text-black">
            {{ _productInfo?.title ? _productInfo.title : ('product.unavailable' | translate )}}
          </sd-title>
        }
        <div class="c__ref-purchase" [ngClass]="{'has-read-more': _productInfo?.refSAV?.length > numberOfRefSavToDisplay && !_showAllRef}">
          @if ((_productInfo?.code && !_productInfo?.bundle) || (_productInfo?.refSAV && !_productInfo?.bundle)) {
            <p class="is-caption c__ref">
              @if (_productInfo?.code && !_productInfo?.bundle) {
                <span>
                  {{ 'product.ref' | translate }} {{ _productInfo?.code }}
                </span>
              }
              @if (_productInfo?.refSAV && !_productInfo?.bundle && !_showAllRef) {
                <span>
                  @for (refSAV of _productInfo?.refSAV | slice:0:numberOfRefSavToDisplay; track refSAV) {
                    <ng-container
                      *ngTemplateOutlet="templateRefSAV;
                      context: {
                        refSAV: refSAV,
                        hasComma: $index < (numberOfRefSavToDisplay - 1) && _productInfo?.refSAV?.length > 1
                      }"
                    />
                  }
                  @if (((_productInfo?.url || _productInfo?.urlCsp) && !_isLoading) && !(_productInfo?.refSAV?.length > numberOfRefSavToDisplay)) {
                    <sd-link
                      [indexFollow]="indexFollow()"
                      customClass="is-full-area"
                      [link]="{url: _productInfo.urlCsp ? _productInfo.urlCsp : _productInfo.url}"
                      (click)="onLinkClick()"
                    >
                      <span class="is-visually-hidden">
                        {{_productInfo.title}}
                      </span>
                    </sd-link>
                  }
                  @if (_productInfo?.refSAV?.length > numberOfRefSavToDisplay) {
                    <span>...</span>
                    <button type="button" class="c__toggle is-link is-full-area" (click)="onClickReadMore(_productInfo?.url)">
                      <span class="is-caption is-bold">{{ 'actions.readMore' | translate }}</span>
                      <sd-icon name="icon-arrow-right" [size]="iconSize.xs" />
                    </button>
                  }
                </span>
              }
              @if (_productInfo?.refSAV && !_productInfo?.bundle && _showAllRef) {
                <span>
                  @for (refSAV of _productInfo?.refSAV; track refSAV) {
                    <ng-container
                      *ngTemplateOutlet="templateRefSAV;
                      context: {
                        refSAV: refSAV,
                        hasComma: !$last && _productInfo?.refSAV?.length > 1
                      }"
                    />
                  }
                </span>
              }
            </p>
          }
          @if (_isRegistered && _productInfo?.purchasedDate) {
            <p class="is-caption c__purchased-date">
              {{ 'product.purchasedDate' | translate }} {{ _productInfo?.purchasedDate }}
            </p>
          }
        </div>
        @if (_productInfo?.url && (!_isMobile || !_isReadOnly)) {
          <sd-link
            [indexFollow]="indexFollow()"
            customClass="is-full-area"
            [link]="{url: _productInfo.urlCsp ? _productInfo.urlCsp : _productInfo.url}"
            (click)="onLinkClick()"
          >
            <span class="is-visually-hidden">
              {{ _productInfo.title }}
            </span>
          </sd-link>
        }
        @if (_productInfo?.stock?.lowStock) {
          <p class="is-caption c__low-stock">{{ 'cart.stock.lowStock.label' | translate }}</p>
        }
      </div>
      @if (!_isMobile && !_hasNoActions && !_isMinified) {
        <div class="c__actions">
          <ng-container *ngTemplateOutlet="actions" />
        </div>
      }
    }
  </div>

  @if (!_isLoading) {
    <div class="c__content-right {{_isRegistered && !_isReadOnly ? 'is-registered' : ''}}">
      @if (!_isRegistered) {
        @if (_productInfo?.totalPrice && (!isOrder() || (isOrder() && !_productInfo?.bundle))) {
          <div class="c__price">
            <ng-container *ngTemplateOutlet="price" />
            @if (_productInfo?.isTaxesIncluded) {
              <span class="is-caption">
                {{'product.taxesIncluded' | translate }}
              </span>
            }
            @if (_isReadOnly && !isWishList()) {
              <span class="is-caption c__quantity-label">
                {{ 'product.quantityLabel' | translate}} <b>{{ _productInfo?.quantity }}</b>
              </span>
            }
          </div>
        }
        @if (!_isMobile && !_isReadOnly) {
          <sd-form
            select
            #quantitySelector
            [items]="itemQty()"
            [labelTitle]="'product.a11y.quantityLabel' | translate: {
              productName: _productInfo?.title,
              productCode: _productInfo?.code
            }"
            (valueChanged)="notifyQuantity()"
            [labelHidden]="false"
            valueKey="value"
            [selectedValue]="{ value: updatedSelectedValue() }"
            libelleKey="value"
            nameField="selectQuantity"
            [disabled]="quantityDisabled()"
          />
        }
      }
      @if (_isRegistered && !_isReadOnly) {
        <sd-form
          select
          #daySelector
          [items]="daysArr"
          [selectedValue]="defaultSelectedDay"
          (valueChanged)="updateRegistrationDate(true)"
          [labelTitle]="'actions.wishlist.libelle.day' | translate"
          [labelHidden]="false"
          valueKey="value"
          libelleKey="value"
          nameField="registeredDay"
          [required]="true"
          [disabled]="false"
        />
        <sd-form
          select
          #monthSelector
          [items]="monthsArr"
          [selectedValue]="defaultSelectedMonth"
          (valueChanged)="updateRegistrationDate(false)"
          [labelTitle]="'actions.wishlist.libelle.month' | translate"
          [labelHidden]="false"
          valueKey="value"
          libelleKey="value"
          nameField="registeredMonth"
          [required]="true"
          [disabled]="false"
        />
        <sd-form
          select
          #yearSelector
          [items]="yearArr()"
          [selectedValue]="defaultSelectedYear"
          (valueChanged)="updateRegistrationDate(false)"
          [labelTitle]="'actions.wishlist.libelle.year' | translate"
          [labelHidden]="false"
          valueKey="value"
          libelleKey="value"
          nameField="registeredYear"
          [required]="true"
          [disabled]="false"
        />
      }
    </div>
  }
</div>

@if ((_isReadOnly && links()) || (_isMobile && !_hasNoActions && !_isMinified)) {
  <div class="c__actions">
    @if (_isLoading) {
      <sd-skeleton
        [appearance]="skeletonAppearanceEnum.line"
        [sizeChangeMobile]="false"
        [count]="1"
      />
    }
    @if (_isReadOnly && links() && !_isLoading) {
      <ul sd-list-inline [class]="_isMobile ? 'is-s' : 'is-m'">
        @for (link of links(); track link) {
          <li>
            <sd-link customClass="is-caption is-semi-bold" [link]="link" (click)="onLinkClick()">
              {{ link.linkName }}
            </sd-link>
          </li>
        }
      </ul>
    }
    @if (_isMobile && !_hasNoActions && !_isMinified && !_isLoading) {
      <ng-container *ngTemplateOutlet="actions" />
    }
  </div>
}

@if (_productInfo?.bundle) {
  <ul class="c__bundle" sd-list-block>
    @for (bundle of _productInfo?.bundle; track bundle) {
      <li class="c__body" [ngClass]="{'is-free-gift': bundle?.isFree}">
        <sd-banner
          [media]="bundle?.media ? bundle.media : defaultMedia"
          [isComponentLoading]="_isLoading"
          [hasAltText]="false"
          [isFit]="true"
          class="c__media-wrapper {{ imageHasBorder ? 'has-border' : '' }}"
          [imgRatio]="imageRatio"
        />
        <div class="c__content-left">
          @if (_isLoading) {
            <sd-skeleton
              [appearance]="skeletonAppearanceEnum.line"
              [sizeChangeMobile]="false"
              [count]="4"
            />
          }
          @if (!_isLoading) {
            @if (bundle?.isFree) {
              <sd-title class="c__free-gift-title" [isDescription]="true" customClass="is-caption is-bold is-text-black">
                {{ 'product.free.gift' | translate }}
              </sd-title>
            }
            <sd-title customClass="brand--h6 is-bold is-text-dark">
              {{ bundle?.title ? bundle?.title : ("product.unavailable" | translate )}}
            </sd-title>
            @if (bundle?.url) {
              <sd-link [indexFollow]="indexFollow()"
                customClass="is-full-area"
                [link]="{url: bundle.url}"
                (click)="onLinkClick()"
              >
                <span class="is-visually-hidden">
                  {{bundle?.title}}
                </span>
              </sd-link>
            }
          }
        </div>
        @if (isOrder() && bundle?.totalPrice && !_isLoading) {
          <div class="c__content-right">
            <div class="c__price">
              <p class="brand--h5 is-bold">
                @if (!bundle?.recommendedPrice || !bundle?.isDiscountWithRecommendedPrice) {
                  <span [class]="bundle.discountedPrice ? 'is-old-price' : 'is-text-dark'">
                    <span class="is-visually-hidden">{{ 'product.price.initialPrice' | translate }}</span>
                    <span class="is-price-through">  {{ bundle?.totalPrice }}
                      <sd-converted-price
                        textBeforePrice="/ "
                        [displayComponent]="!bundle?.discountedPrice"
                        [price]="bundle?.totalPrice"
                      />
                    </span>
                  </span>
                }
                @if (bundle?.discountedPrice) {
                  <span class="is-visually-hidden">{{ 'product.price.reducedPrice' | translate }}</span>
                  <span [ngClass]="{'is-text-dark': bundle?.recommendedPrice || bundle?.isDiscountWithRecommendedPrice}">
                    {{ bundle?.discountedPrice }}
                    <sd-converted-price
                      textBeforePrice="/ "
                      [price]="bundle?.discountedPrice"
                      [sourceCurrencyIsocode]="_sourceCurrencyIsocode"
                    />
                  </span>
                }
              </p>
              @if (bundle?.promo) {
                <span class="is-caption is-bold" [attr.data-color]="'primary-base'">
                  {{bundle?.promo}}
                </span>
              }
              @if (!_isMinified && _isReadOnly ? bundle?.quantity > 1 : quantitySelector()?.internalField?.value > 1) {
                <span class="is-caption">
                  {{ 'product.unitPrice' | translate }} {{ bundle?.price }}
                </span>
              }
              @if (_productInfo?.isTaxesIncluded) {
                <span class="is-caption">
                  {{'product.taxesIncluded' | translate }}
                </span>
              }
              @if (bundle.discountedPrice && (bundle?.recommendedPrice || bundle?.isDiscountWithRecommendedPrice)) {
                <span class="is-caption">
                  {{ 'product.price.recommendedPrice' | translate }}: {{ bundle?.totalPrice }}
                </span>
              }
              @if (_isReadOnly && !isWishList()) {
                <span class="is-caption c__quantity-label">
                  {{ 'product.quantityLabel' | translate}} <b>{{ bundle?.quantity }}</b>
                </span>
              }
            </div>
          </div>
        }
      </li>
    }
  </ul>
}

@if (_productInfo?.url && !_isLoading) {
  <sd-link
    [indexFollow]="indexFollow()"
    customClass="is-full-area"
    [link]="{url: _productInfo.urlCsp ? _productInfo.urlCsp : _productInfo.url}"
    (click)="onLinkClick()"
  >
    <span class="is-visually-hidden">
      {{_productInfo.title}}
    </span>
  </sd-link>
}

<ng-template #price>
  @if (!_isLoading) {
    @if (!isWishList()) {
      <p class="brand--h5 is-bold">
        @if ((_productInfo?.discountedPrice || _productInfo?.recommendedPrice || !(_productInfo?.discountedPrice && _productInfo?.recommendedPrice))) {
          <span [class]="_productInfo.discountedPrice ? 'is-old-price' : 'is-text-dark'">
            <span class="is-visually-hidden">{{ 'product.price.initialPrice' | translate }}</span>
            @if (!_productInfo?.isDiscountWithRecommendedPrice || (_productInfo?.isDiscountWithRecommendedPrice && !_productInfo?.discountedPrice)) {
              <span class="is-price-through"> {{ _productInfo?.totalPrice }} </span>
              <sd-converted-price
                textBeforePrice="/ "
                [displayComponent]="!_productInfo.discountedPrice"
                [price]="_productInfo?.totalPrice"
                [sourceCurrencyIsocode]="_sourceCurrencyIsocode"
              />
            }
            @if (_productInfo?.discountedPrice && !isBundle() && !_productInfo?.isDiscountWithRecommendedPrice) {
              <span>*</span>
            }
          </span>
        }
        @if (_productInfo.discountedPrice) {
          <span class="is-visually-hidden">{{ 'product.price.reducedPrice' | translate }}</span>
          <span [ngClass]="{'is-text-dark': (_productInfo?.recommendedPrice && !_productInfo.discountedPrice) || _productInfo?.isDiscountWithRecommendedPrice}">
            {{ _productInfo.discountedPrice }}
            <sd-converted-price
              textBeforePrice="/ "
              [price]="_productInfo.discountedPrice"
              [sourceCurrencyIsocode]="_sourceCurrencyIsocode"
            />
          </span>
        }
      </p>
      @if (_productInfo.discountedPrice && !isBundle() && !_productInfo?.isDiscountWithRecommendedPrice && (!_productInfo?.promo || _productInfo.isAnAlreadyDiscountedProduct)) {
        <span class="is-text-dark d-block c__discount-price-message is-overline">
          * {{('product.strikethroughPrice.message' | translate) }}
        </span>
      }
      @if (_productInfo?.promo) {
        <span class="is-caption is-bold c__promo-wrapper" [attr.data-color]="'primary-base'">
          {{_productInfo?.promo}}
        </span>
      }
      @if ( _productInfo?.quantity > 1 ) {
        <span class="is-caption">
          {{ 'product.unitPrice' | translate }} {{_productInfo?.basePrice ? _productInfo?.basePrice?.formattedValue : _productInfo?.price}}
        </span>
      }
      @if ((_productInfo?.recommendedPrice && !_productInfo?.isDiscountWithRecommendedPrice) || (_productInfo?.discountedPrice && _productInfo?.isDiscountWithRecommendedPrice)) {
        <span class="is-caption c__recommended-price-wrapper {{_isMobile ? 'is-mobile':''}}" (click)="onopenRecommendedPriceModal()">
          <span class="c__recommended-text">{{ 'product.price.recommendedPrice' | translate }}
            @if (!_productInfo?.discountedPrice) {
              <span>*</span>
            }
          </span>
          <span class="c__recommended-button">
            <sd-icon name="icon-help" [size]="iconSize.xs" />
          </span>
          <span class="c__recommended-price">
            {{ !_productInfo?.isDiscountWithRecommendedPrice ? _productInfo?.recommendedPrice : _productInfo?.totalPrice }}
          </span>
        </span>
      }
    } @else {
      <p class="brand--h5 is-bold">
        <span class="is-text-dark">
          <span class="is-visually-hidden">{{ 'product.price.initialPrice' | translate }}</span>
          {{ _productInfo?.price }}
          <sd-converted-price
            textBeforePrice="/ "
            [price]="_productInfo.price"
            [sourceCurrencyIsocode]="_sourceCurrencyIsocode"
          />
        </span>
      </p>
    }
  }
  @if (_isLoading) {
    <sd-skeleton
      [appearance]="skeletonAppearanceEnum.line"
      [sizeChangeMobile]="false"
      [count]="1"
    />
  }
</ng-template>

<ng-template #actions>
  @if (!_isLoading) {
    <ul sd-list-inline [class]="_isMobile ? 'is-s' : 'is-m'">
      @if (_isRegistered && _isReadOnly && displayProductAssets()) {
        <li>
          <button sd-button-icon
            [titleHidden]="false"
            class="c__icon"
            [size]="iconSize.small"
            [buttonIconTitle]="('product.instructions' | translate)"
            icon="icon-brand-xs"
            (click)="productInstruction()"
          ></button>
        </li>
      }
      @if (_isRegistered && _isReadOnly && displayProductAssets()) {
        <li>
          <button sd-button-icon
            [titleHidden]="false"
            [size]="iconSize.small"
            [buttonIconTitle]="('product.warranty' | translate)"
            icon="icon-document"
            (click)="productWarranty()"
          ></button>
        </li>
      }
      @if ((!canAddToCart() && !_isRegistered) || (_isReadOnly && _isRegistered)) {
        <li>
          <button sd-button-icon
            [titleHidden]="false"
            [size]="iconSize.small"
            [buttonIconTitle]="('actions.remove' | translate)"
            icon="icon-trash"
            (click)="deleteProduct()"
          ></button>
        </li>
      }
      @if (canAddToCart()) {
        <li>
          <button sd-button-icon
            [titleHidden]="false"
            [size]="iconSize.small"
            [buttonIconTitle]="('actions.product.add' | translate)"
            icon="icon-cart"
            (click)="addToCart()"
          ></button>
        </li>
      }
      @if (!_isRegistered && showWishList) {
        <li>
          <button sd-button-icon
            [titleHidden]="false"
            [size]="iconSize.small"
            [buttonIconTitle]="(_productInfo?.isInFavorite ? 'wishlist.remove' : 'wishlist.add' | translate)"
            icon="icon-heart-filled"
            (click)="addToFavorite()"
            class="{{ _productInfo?.isInFavorite ? 'is-active' : 'is-unactive' }}"
          ></button>
        </li>
      }
    </ul>
  }

  @if (_isLoading) {
    <sd-skeleton
      [appearance]="skeletonAppearanceEnum.line"
      [sizeChangeMobile]="false"
      [count]="1"
    />
  }
</ng-template>

<ng-template #templateRefSAV let-refSAV="refSAV" let-hasComma="hasComma">
  {{ refSAV }}
  @if (hasComma) {
    <span>, </span>
  }
</ng-template>
